import React, { useState, useEffect } from "react";

// Style sheet
import "bootstrap/dist/css/bootstrap.min.css";
import "../scss/oceanMap.scss";
// mapTitle sheet
import "../scss/mapTitleMap.scss";

// leaflet css
import "leaflet/dist/leaflet.css";
import "leaflet-defaulticon-compatibility/dist/leaflet-defaulticon-compatibility.css";
import "leaflet-defaulticon-compatibility";

// Openstreetmap components
import {
  MapContainer,
  TileLayer,
  Marker,
  ZoomControl,
  Polyline,
  Popup,
  useMap,
} from "react-leaflet";
// L component
import * as Leaflet from "leaflet";

// Watermark
import Watermark from "../../../../resources/image/watermark.jpg";

import data from "../../../../resources/20230901-2130-sccw_json_datagov_uc.json";

import { getOceanWeatherInformation } from "../../../service/apiWeatherInfoService";

const generateArcPoints = (
  center: [number, number],
  radius: number,
  startAngle: number,
  endAngle: number,
  numPoints: number
): [number, number][] => {
  const points: [number, number][] = [];
  const angleStep = (endAngle - startAngle) / numPoints;

  for (let i = 0; i <= numPoints; i++) {
    const angle = startAngle + i * angleStep;
    const radian = (Math.PI / 180) * angle;
    const lat = center[0] + (radius * Math.cos(radian)) / 111320;
    const lng =
      center[1] +
      (radius * Math.sin(radian)) /
        (111320 * Math.cos(center[0] * (Math.PI / 180)));
    points.push([lat, lng]);
  }

  return points;
};

//#region Fatch received jsonarray to array<object>
function KeyFatch(keyFatchSource: Object): Array<oceanInfo_Props> {
  let weatherInformationArray: Array<oceanInfo_Props> =
    new Array<oceanInfo_Props>();

  try {
    const keys = Object.keys(keyFatchSource) as Array<string>;

    if (keys.length === 0) {
      return weatherInformationArray;
    }

    keys.forEach((key) => {
      let keyItem: any = keyFatchSource[key as keyof typeof keyFatchSource];

      let humItem: oceanInfo_Props = {
        location: keyItem.location,
        windInfo: keyItem.windInfo,
        weatherDescription: keyItem.weatherDescription,
        seaSituation: keyItem.seaSituation,
      };
      weatherInformationArray.push(humItem);
    });
  } catch (exception) {
    weatherInformationArray = new Array<oceanInfo_Props>();
  }

  return weatherInformationArray;
}
//#endregion

//#region Fatch ocean warning text
function FetchWarning(
  WarningSource: Array<oceanInfo_Props>,
  windForce: number
): string {
  let warningArea: string = "";
  //console.log("len = "+f12.length);
  WarningSource.forEach(function (value) {
    switch (windForce) {
      case 12:
        if (value.windInfo.includes("12")) {
          //console.log(value);
          warningArea += value.location + "、";
        }
        break;
      case 10:
        if (value.windInfo.includes("10") || value.windInfo.includes("11")) {
          if (value.windInfo.includes("12")) {
            break;
          }

          warningArea += value.location + "、";
        }
        break;
      case 8:
        if (value.windInfo.includes("8") || value.windInfo.includes("9")) {
          if (
            value.windInfo.includes("10") ||
            value.windInfo.includes("11") ||
            value.windInfo.includes("12")
          ) {
            break;
          }

          warningArea += value.location + "、";
        }
        break;
      case 6:
        if (value.windInfo.includes("6") || value.windInfo.includes("7")) {
          if (
            value.windInfo.includes("8") ||
            value.windInfo.includes("9") ||
            value.windInfo.includes("10") ||
            value.windInfo.includes("11") ||
            value.windInfo.includes("12")
          ) {
            break;
          }

          warningArea += value.location + "、";
        }
        break;
    }
  });

  if (warningArea.substr(warningArea.length - 1) === "、") {
    warningArea = warningArea.substr(0, warningArea.length - 1);
  }

  return warningArea;
}
//#endregion

//#region Fatch ocean warning text style
function WarningStyle(warningF: number, area: string) {
  if (area.length === 0) {
    return;
  }

  switch (warningF) {
    case 6:
      return (
        <div className="oceanMapWindWarning">
          <div
            className="oceanMapWindWarningTitle"
            id="oceanMapStrongWarningTitle"
          >
            海上強風警報
          </div>
          <div className="oceanMapWindWarningDetails">{area}</div>
        </div>
      );
    case 8:
      return (
        <div className="oceanMapWindWarning">
          <div
            className="oceanMapWindWarningTitle"
            id="oceanMapGaleWarningTitle"
          >
            海上烈風警報
          </div>
          <div className="oceanMapWindWarningDetails">{area}</div>
        </div>
      );
    case 10:
      return (
        <div className="oceanMapWindWarning">
          <div
            className="oceanMapWindWarningTitle"
            id="oceanMapStormWarningTitle"
          >
            海上暴風警報
          </div>
          <div className="oceanMapWindWarningDetails">{area}</div>
        </div>
      );
    case 12:
      return (
        <div className="oceanMapWindWarning">
          <div
            className="oceanMapWindWarningTitle"
            id="oceanMapHurrianeWarningTitle"
          >
            海上颶風警報
          </div>
          <div className="oceanMapWindWarningDetails">{area}</div>
        </div>
      );
  }
}
function NoneWarningStyle() {
  return (
    <div>
      <div>無</div>
    </div>
  );
}
function WarningInfoPopup(windInfo: string) {
  if (windInfo.includes("12")) {
    return (
      <div id="warningInfoPopup_12" className="warningInfoPopup">
        海上颶風警報
      </div>
    );
  } else if (windInfo.includes("10") || windInfo.includes("11")) {
    return (
      <div id="warningInfoPopup_10" className="warningInfoPopup">
        海上暴風警報
      </div>
    );
  } else if (windInfo.includes("8") || windInfo.includes("9")) {
    return (
      <div id="warningInfoPopup_8" className="warningInfoPopup">
        海上烈風警報
      </div>
    );
  } else if (windInfo.includes("6") || windInfo.includes("7")) {
    return (
      <div id="warningInfoPopup_6" className="warningInfoPopup">
        海上強風警報
      </div>
    );
  }
}
//#endregion

//#region Get the location of warning
function WarningAreaConvert(location: string): String {
  switch (location) {
    case "香港鄰近海域":
      location = "HKAdj";
      break;
    case "南澳以南":
      location = "NanAo";
      break;
    case "汕尾以南":
      location = "ShanWei";
      break;
    case "香港以南":
      location = "SHK";
      break;
    case "沙堤以南":
      location = "Shangchuan";
      break;
    case "海南島東南沿岸":
      location = "SEHainan";
      break;
    case "北部灣以南":
      location = "SBeibuGulf";
      break;
  }
  return location;
}
function WarningAreaLocation(location: String): Leaflet.LatLngExpression {
  let result: Leaflet.LatLngExpression = [0, 0];

  switch (location) {
    case "HKAdj":
      result = [21.8, 114.1];
      break;
    case "NanAo":
      result = [22.4, 117.7];
      break;
    case "ShanWei":
      result = [21.75, 115.85];
      break;
    case "SHK":
      result = [20.75, 114.1];
      break;
    case "Shangchuan":
      result = [20.5, 112.45];
      break;
    case "SEHainan":
      result = [18.5, 110.75];
      break;
    case "SBeibuGulf":
      result = [17.8, 108.0];
      break;
  }

  return result;
}
function WarningAreaColor(windInfo: string): String {
  let result: string = "";

  if (windInfo.includes("12")) {
    result = "black";
  } else if (windInfo.includes("10") || windInfo.includes("11")) {
    result = "rgb(255, 0, 255)";
  } else if (windInfo.includes("8") || windInfo.includes("9")) {
    result = "red";
  } else if (windInfo.includes("6") || windInfo.includes("7")) {
    result = "yellow";
  } else {
    result = "white";
  }

  return result;
}
function WarningBoxIcon(locationWeather: oceanInfo_Props): Leaflet.DivIcon {
  //console.log(locationWeather.windInfo);

  var iconSize: Leaflet.PointExpression = [25, 25];
  var color: String = WarningAreaColor(locationWeather.windInfo);

  var markerHtmlStyles: string = `width: 25px; height: 25px; background-color: ${color}; margin: 0px;`;

  const icon = Leaflet.divIcon({
    className: "",
    html: `<div style="${markerHtmlStyles}"></div>`,
    iconSize: iconSize,
  });

  return icon;
}
//#endregion

//#region border in map
const nanAoEastBorder: Leaflet.LatLngExpression[] = [
  [24.5122479, 118.5728811],
  [21.2, 118.5728811],
];
const nanAoShanWeiBorder: Leaflet.LatLngExpression[] = [
  [23.2359819, 116.8060861],
  [20.686643, 116.8060861],
];
const shanWeiHKBorder: Leaflet.LatLngExpression[] = [
  [22.5513989, 114.9001751],
  [20.125, 114.9001751],
];
const hkShangchuanDaoBorder: Leaflet.LatLngExpression[] = [
  [21.876743, 113.2628721],
  [19.641006, 113.2628721],
];
const shangchuanDaoWestBorder: Leaflet.LatLngExpression[] = [
  [21.51431, 111.6457101],
  [18.345, 111.6457101],
];
const hainanSouthBorder: Leaflet.LatLngExpression[] = [
  [18.1580531, 109.5755121],
  [16.6700771, 109.5755121],
];
const hainanNorthBorder: Leaflet.LatLngExpression[] = [
  [20.469931, 111.6457101],
  [20.012714, 110.9297371],
];
const beibuGulfBorder: Leaflet.LatLngExpression[] = [
  [18.8226681, 108.6262631],
  [18.8226681, 105.7551501],
];
const beibuGulfSouthBorder: Leaflet.LatLngExpression[] = [
  [16.6700771, 109.5755121],
  [16.6700771, 107.45],
];
const allSouthBorder: Leaflet.LatLngExpression[] = [
  [16.6700771, 109.5755121],
  [19.641006, 113.2628721],
  [20.686643, 116.8060861],
  [21.2, 118.5728811],
];
const hkNeighbourPoints = generateArcPoints(
  [22.3022517, 114.1744549],
  105 * 1000,
  134.6,
  243.4,
  60
);
//#endregion

//#region Map Watermark
const WatermarkControl = () => {
  const map = useMap();
  const watermark = map.getContainer().querySelector(".watermark");

  if (!watermark) {
    const watermark = new Leaflet.Control({ position: "bottomleft" });
    watermark.onAdd = function (map) {
      var div = Leaflet.DomUtil.create("div", "watermark");
      div.innerHTML = "<img src='" + Watermark + "' width='75' height='75'>";
      return div;
    };
    watermark.addTo(map);
    // React.useEffect(() => {

    // }, [map]);
  }

  return null;
};

//#endregion END

const dottedLineOptions = {
  color: "black",
  weight: 1,
  dashArray: "5, 5", // 5px dash, 10px gap
};

type oceanInfo_Props = {
  location: string;
  windInfo: string;
  weatherDescription: string;
  seaSituation: string;
};

export default function OceanMap() {
  const position: Leaflet.LatLngExpression = [22.35, 114.125];
  const [oceanArray, setOceanArray] = useState<Array<oceanInfo_Props>>([]);

  async function getOceanInfomation() {
    await getOceanWeatherInformation()
      .then((response) => {
        return response.data.data;
      })
      .then((data) => {
        try {
          if (
            data !== null ||
            data !== undefined ||
            data.length !== 0 ||
            data.message !== "Internal server error"
          ) {
            setOceanArray(KeyFatch(data.areaForcast));
          }
        } catch (err) {
          setOceanArray(new Array<oceanInfo_Props>());
        }
      });
  }

  function tmp() {
    var areaForcast: Array<oceanInfo_Props> = KeyFatch(data.data.areaForcast);
    setOceanArray(areaForcast);
  }

  useEffect(() => {
    getOceanInfomation();
    //tmp();
  }, []);

  return (
    <div id="oceanMap">
      <div>
        <div id="oceanMapCurrentWindWarning">現時海上警報</div>
        {FetchWarning(oceanArray, 12) === "" &&
          FetchWarning(oceanArray, 10) === "" &&
          FetchWarning(oceanArray, 8) === "" &&
          FetchWarning(oceanArray, 6) === "" &&
          NoneWarningStyle()}
        {WarningStyle(12, FetchWarning(oceanArray, 12))}
        {WarningStyle(10, FetchWarning(oceanArray, 10))}
        {WarningStyle(8, FetchWarning(oceanArray, 8))}
        {WarningStyle(6, FetchWarning(oceanArray, 6))}
      </div>
      <div className="mapContainerSouthChinaOcean">
        <MapContainer
          zoom={7}
          maxZoom={7}
          minZoom={6}
          zoomControl={false}
          center={position}
          scrollWheelZoom={false}
        >
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />

          <Polyline
            pathOptions={dottedLineOptions}
            positions={nanAoEastBorder}
          />
          <Polyline
            pathOptions={dottedLineOptions}
            positions={nanAoShanWeiBorder}
          />
          <Polyline
            pathOptions={dottedLineOptions}
            positions={shanWeiHKBorder}
          />
          <Polyline
            pathOptions={dottedLineOptions}
            positions={hkShangchuanDaoBorder}
          />
          <Polyline
            pathOptions={dottedLineOptions}
            positions={shangchuanDaoWestBorder}
          />

          <Polyline
            pathOptions={dottedLineOptions}
            positions={hainanSouthBorder}
          />
          <Polyline
            pathOptions={dottedLineOptions}
            positions={hainanNorthBorder}
          />

          <Polyline
            pathOptions={dottedLineOptions}
            positions={beibuGulfBorder}
          />
          <Polyline
            pathOptions={dottedLineOptions}
            positions={beibuGulfBorder}
          />
          <Polyline
            pathOptions={dottedLineOptions}
            positions={beibuGulfSouthBorder}
          />

          <Polyline
            pathOptions={dottedLineOptions}
            positions={allSouthBorder}
          />

          <Polyline
            pathOptions={dottedLineOptions}
            positions={hkNeighbourPoints}
          />

          <ZoomControl position="topright" />

          {oceanArray.map((item) => {
            var warningArea: String = WarningAreaConvert(item.location);
            return (
              <Marker
                key={"temp-" + warningArea}
                position={WarningAreaLocation(warningArea)}
                icon={WarningBoxIcon(item)}
              >
                <Popup>
                  <div>
                    <div className="popupfont popupTitle">{item.location}</div>
                    <div className="popupfont popupWarning">
                      {WarningInfoPopup(item.windInfo)}
                    </div>
                    <div className="popupfont">{item.windInfo}</div>
                    <div className="popupfont">{item.weatherDescription}</div>
                    <div className="popupfont">{item.seaSituation}</div>
                  </div>
                </Popup>
              </Marker>
            );
          })}

          <WatermarkControl />
        </MapContainer>
      </div>
    </div>
  );
}
